import req from "../../methods/req"

//上传图片
export const uploadFile = function (data) {
    let url = '/manage/common.upload/file'
    return req({
        url: url,
        ...data,
        mode: 'upload'
    })
}

//文件选择器
export const imageList = function (data) {
    let url = '/manage/common.upload/image'
    return req({
        url: url,
        ...data,
    })
}



//获取省市区三级联动
export const getCity = function (data) {
    let url = '/manage/common.city/getCity'
    return req({
        url: url,
        ...data
    })
}

//获取当前用户信息
export const getCurrentUser = function (data) {
    let url = '/manage/auth.system/getCurrentUser'
    return req({
        url: url,
        ...data
    })
}
//系统用户修改密码
export const modifyPassword = function (data) {
    let url = '/manage/auth.user/modifyPassword'
    return req({
        url: url,
        ...data
    })
}
// 验证码
export const codeVar = function (data) {
    let url = '/manage/common.index/sendSms'
    return req({
        url: url,
        ...data
    })
}

// oss
export const ossFile = function (data) {
    let url = '/manage/common.upload/ossFile'
    return req({
        url: url,
        ...data
    })
}

// 上传图片base64图片
export const uploadBaseImage = function (data) {
    let url = '/manage/common.upload/uploadBaseImage'
    return req({
        url: url,
        ...data
    })
}

// 获取可选sku名称
export const getSkuList = function (data) {
    let url = '/manage/goods.index/getSkuList'
    return req({
        url: url,
        ...data
    })
}

// 添加品牌
export const addBrand = function (data) {
    let url = '/manage/goods.index/addBrand'
    return req({
        url: url,
        ...data
    })
}

// 匹配是否有重复
export const searchById = function (data) {
    let url = '/manage/shop.O2O/searchById'
    return req({
        url: url,
        ...data
    })
}

// 可选分组
export const getGroupCate = function (data) {
    let url = '/manage/common.group/getGroupCate'
    return req({
        url: url,
        ...data
    })
}

// 修改图片分组
export const editFile = function (data) {
    let url = '/manage/common.group/editFile'
    return req({
        url: url,
        ...data
    })
}

// 新增
export const AddGroup = function (data) {
    let url = '/manage/common.group/add'
    return req({
        url: url,
        ...data
    })
}
// 核销码启用禁用
export const codeDisable = function (data) {
    return req({
        url: '/channel/shop.O2O/disable',
        ...data
    })
}

//登录
export const getLoginInfo = function (data) {
    return req({
      url: '/manage/common.index/login',
      ...data
    })
  }
//登录  -- 验证码
export const getLoginInfoTwo = function (data) {
    return req({
      url: '/manage/common.index/loginPhone',
      ...data
    })
  }
  //获取当前用户菜单
  export const getCurrentMenu = function (data) {
    return req({
      url: '/manage/auth.system/getCurrentMenu',
      ...data
    })
  }
